import { mentionFactory } from "../../sked-editor/social-mention/mention-decorator-node";

const {
  NodeClass: SkedSocialMentionNode,
  $createMentionNode: $createSkedSocialMentionNode,
  $isMentionNode: $isSkedSocialMentionNode,
} = mentionFactory({
  nodeName: "social-mention-node",
  renderNode: (mention, { isSelected }) => {
    return (
      <span
        className={`inline ${isSelected ? "outline-dotted outline-blue-500" : ""} relative  text-blue-500 cursor-default font-semibold`}
      >
        {mention.__text}
      </span>
    );
  },
});

export {
  SkedSocialMentionNode,
  $createSkedSocialMentionNode,
  $isSkedSocialMentionNode,
};
